import { render } from "./TagCreate.vue?vue&type=template&id=694e8683"
import script from "./TagCreate.vue?vue&type=script&lang=js"
export * from "./TagCreate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/maskansazangolchin-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__